<template>
  <v-container class="ma-0 pa-0 px-2" v-if="calendar">

    <!-- next appointment -->
    <v-row no-gutters align-content="start" justify="space-between" class="pb-5"
      v-if="calendar.nextPatientSchedule && calendar.nextPatientSchedule.status == 'scheduled'">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption">
        Próxima consulta:
      </v-col>
      <v-col no-gutters xl="5" lg="5" md="5" sm="5" cols="11">
        <patient-next-schedule v-model="calendar.nextPatientSchedule" />
      </v-col>
    </v-row>

    <!-- last appointment -->
    <v-row v-if="calendar.lastPatientSchedule" no-gutters align="center"
      justify="space-between" class="pb-5">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption">
        Última consulta realizada:
      </v-col >
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
        {{ calendar.lastPatientSchedule.date | dateToLongDate }}
      </v-col>
    </v-row>

    <v-divider v-if="calendar.nextPatientScheduleDate || calendar.lastScheduleAttended"></v-divider>

    <!-- speciality -->
    <v-row no-gutters align="center" justify="space-between" class="pb-5">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption"
        >Especialidade:</v-col
      >
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
        {{ calendar.speciality }}
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <!-- address -->
    <v-row no-gutters align="center" justify="space-between" class="pb-5">
      <!-- infos -->
      <v-col xl="7" lg="7" md="7" sm="7" cols="12">
        <v-row no-gutters align="start" justify="start" class="pa-0 ma-0">
          <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption">
            Endereço:
          </v-col>
          <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-1 body-2">{{
            `${calendar.street}, ${calendar.number}`
          }}</v-col>
          <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-1 body-2">{{
            `${calendar.zip} - ${calendar.district}`
          }}</v-col>
          <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-1 body-2">{{
            `${calendar.city} - ${calendar.state}`
          }}</v-col>
        </v-row>
      </v-col>

      <!-- map -->
      <v-col xl="5" lg="5" md="5" sm="5" cols="12" class="pt-2">
        <location-view :latitude="Number(calendar.latitude)"
          :longitude="Number(calendar.longitude)" width="100%"/>
      </v-col>

    </v-row>

    <v-divider></v-divider>

    <!-- next calendar date schedule -->
    <v-row no-gutters align="center" justify="space-between" class="pb-5">
      <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="4">
        <!-- date -->
        <v-row no-gutters justify="space-between">
          <v-col no-gutters xl="9" lg="9" sm="9" cols="9" class="pb-2 caption">
            Próxima consulta:
          </v-col>
          <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
            {{ calendar.nextSchedules | date }}
          </v-col>
        </v-row>
      </v-col>
      <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="4">
        <!-- times -->
        <v-row no-gutters justify="space-around">
          <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption">
            Horários Disponíveis:
          </v-col>
          <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
            {{ calendar.totalTimes }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-divider v-if="calendar.agendaInfo"></v-divider>

    <!-- infos -->
    <v-row v-if="calendar.agendaInfo" no-gutters
      align="center" justify="space-between" class="pb-5" >
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption">
        Informações Complementares:
      </v-col>
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
        {{ calendar.agendaInfo }}
      </v-col>
    </v-row>

    <v-divider v-if="calendar.covenant"></v-divider>

    <!-- covenants -->
    <v-row no-gutters align="center" justify="space-between" class="pb-5" v-if="calendar.covenant">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption">Convênios:</v-col>
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
        {{ calendar.covenant }}
      </v-col>
    </v-row>

    <v-divider v-if="calendar.price"></v-divider>

    <!-- particular (price) -->
    <v-row no-gutters align="center" justify="space-between" class="pb-5" v-if="calendar.price">
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="pb-2 caption">
        Consulta Particular:
      </v-col>
      <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9" class="subtitle-2">
        {{ calendar.price | currency }}
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import LocationView from '@/components/general/LocationView';
import PatientNextSchedule from '@/components/calendars/PatientNextSchedule';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    calendar: null,
    removeLoading: false,
    confirmRemove: false,
    markers: [
      { id: 'a', position: { lat: 3, lng: 101 } },
    ],
  }),
  created() {
    this.calendar = this.value;
  },
  destroyed() {
    this.confirmRemove = false;
  },
  methods: {
  },
  watch: {
    value(vl) {
      this.calendar = vl;
    },
  },
  components: {
    LocationView,
    PatientNextSchedule,
  },
};
</script>
